import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ArcadiaGreenButtonConnectionDto } from "../dto/arcadia-green-button.dto"
import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type RetryArcadiaGreenButtonConnectionParams = {
  connectionId: string
  proposalId: string
  requestId: string
  siteId: string
}

export const useRetryArcadiaGreenButtonConnection = (): UseMutationResult<
  ArcadiaGreenButtonConnectionDto,
  unknown,
  RetryArcadiaGreenButtonConnectionParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ connectionId, proposalId, requestId, siteId }) =>
      arcadiaGreenButtonService.retryConnection(
        siteId,
        connectionId,
        proposalId,
        requestId,
      ),
    onSuccess: (_data, { siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
    },
  })
}
